import React, { useContext } from 'react'
import { ApplicationContext } from 'App/context'
import { Helmet } from 'react-helmet'
import { Result, Button } from 'antd'
import 'antd/lib/result/style'
import { useHistory } from 'react-router-dom'

const SystemLogout = () => {
  const ctx = useContext(ApplicationContext)
  const history = useHistory()
  React.useEffect(() => {

    if (ctx.extraQueryParams === undefined) {
      ctx.extraQueryParams = {}
    }
    if (ctx.extraTokenParams === undefined) {
      ctx.extraTokenParams = {}
    }

    ctx.extraQueryParams.hootsuiteUserId  = window.sessionStorage.getItem('hootsuiteUserId')
    ctx.extraQueryParams.hootsuiteTimestamp = window.sessionStorage.getItem('hootsuiteTimestamp')
    ctx.extraQueryParams.hootsuitePlacementId = window.sessionStorage.getItem('hootsuitePlacementId')
    ctx.extraQueryParams.hootsuiteToken = window.sessionStorage.getItem('hootsuiteToken')
    ctx.extraQueryParams.messageId = window.sessionStorage.getItem('messageId')
    ctx.extraTokenParams.hootsuiteUserId = window.sessionStorage.getItem('hootsuiteUserId')
    ctx.extraTokenParams.hootsuiteTimestamp = window.sessionStorage.getItem('hootsuiteTimestamp')
    ctx.extraTokenParams.hootsuitePlacementId = window.sessionStorage.getItem('hootsuitePlacementId')
    ctx.extraTokenParams.hootsuiteToken = window.sessionStorage.getItem('hootsuiteToken')
    ctx.extraTokenParams.messageId = window.sessionStorage.getItem('messageId')
    window.sessionStorage.removeItem('hootsuiteUserId')
    window.sessionStorage.removeItem('hootsuiteTimestamp')
    window.sessionStorage.removeItem('hootsuitePlacementId')
    window.sessionStorage.removeItem('hootsuiteToken')
    window.sessionStorage.removeItem('messageId')
  }, [])

  return (
    <>
      <Helmet title="Hootsuite Logout successful" />
      <Result
        status="success"
        title="Hootsuite Logout successful"
        subTitle="You have been logged out. See you soon!"
        extra={[
          <Button key="login" onClick={() => history.push('/login')}>
            Login again
          </Button>,
        ]}
      />
    </>
  )
}

export default {
  name: 'Logout',
  routeProps: {
    path: '/logout_successful',
    component: SystemLogout,
  },
}
